import { useMemo } from "react";
import { eventHideOverridesRef } from "../lib/data/availability";
import { useFirestoreCollection } from "./useFirestoreCollection";

export function useEventHideOverrides(uid) {
  const queryRef = useMemo(
    () => (uid ? eventHideOverridesRef(uid) : null),
    [uid]
  );
  return useFirestoreCollection(queryRef);
}
